import React from 'react';
import ReactDOM from 'react-dom';
import ColumnDialog from './dialog';
import type { ColumnDataCm, ColumnDataEmu, ColumnSpaceCm, ColumnSpaceEmu, IColumnDialogManager, IColumnDialogManagerServiceDelegates } from './interface';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { cmToEmu, emuToCm } from '@src/slide/infrastructure/module/independent/unit';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import expect from '@src/slide/infrastructure/module/independent/assert/expect';

export class ColumnDialogManager implements IColumnDialogManager {
    private dialogContainer = document.createElement('div');
    private originalColumnData: ColumnDataEmu | null;
    private services: IColumnDialogManagerServiceDelegates;

    public setServiceDelegates(services: Partial<IColumnDialogManagerServiceDelegates>) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public showDialog(originalColumnData: ColumnDataEmu) {
        this.originalColumnData = originalColumnData;
        this.updateDialog();
    }

    private hideDialog = () => {
        this.originalColumnData = null;
        ReactDOM.unmountComponentAtNode(this.dialogContainer);
    };

    private changeColumnData = (columnData: ColumnDataCm) => {
        this.reportData(columnData);
        const { columnNumber: newColumnNumber, columnSpace: newColumnSpace } = columnData;
        const { columnNumber: originalColumnNumber, columnSpace: originalColumnSpace } = this.originalColumnData || {};
        const result: ColumnDataEmu = {};
        if (newColumnNumber !== originalColumnNumber) {
            result.columnNumber = newColumnNumber;
        }
        if (expect(newColumnSpace).isNumber() && cmToEmu(newColumnSpace) !== originalColumnSpace) {
            result.columnSpace = (cmToEmu(newColumnSpace) as ColumnSpaceEmu);
        }
        if (Object.keys(result).length > 0) {
            this.services.menuManager.toolbarMenu()
                ?.callback(MenuType.TOOLBAR, ActionType.COLUMNS, result);
        }
        this.hideDialog();
    };

    private reportData(columnData: ColumnDataCm) {
        const { columnNumber, columnSpace } = columnData;
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_TOOLBAR,
            action: TDWActionType.MORE_COLUMNS,
            ver5: columnNumber,
            ver6: columnSpace,
        });
    }

    private updateDialog() {
        const { columnNumber, columnSpace } = this.originalColumnData || {};
        ReactDOM.render(
            (
                <ColumnDialog
                    defaultColumnNumber={columnNumber}
                    defaultColumnSpace={columnSpace && (emuToCm(columnSpace) as ColumnSpaceCm)}
                    onClose={this.hideDialog}
                    onOk={this.changeColumnData}
                />
            ), this.dialogContainer,
        );
    }
}
